import React, { useContext } from "react"
import { Navigate } from "react-router-dom"
import { ProtectRoutesContext } from "../context/ProtectRoutesContext"

const ProtectedRoute = ({ element }) => {
  const { isAuthenticated } = useContext(ProtectRoutesContext)

  return isAuthenticated ? element : <Navigate to="/enter-password" />
}

export default ProtectedRoute;
